var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadShow)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-con"},[_c('div',{class:['boot', 'img_loading']}),_c('p',[_vm._v(_vm._s(_vm.tips))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }